<template>
  <div class="datagrid-item">
    <div class="datagrid-title">Ссылка для проверки</div>
    <div class="datagrid-content mt-1"><b>{{ getVal() }}</b></div>
  </div>
</template>

<script>
import {defineComponent} from "vue"

export default defineComponent({
  name: "UrlCheck",
  props: {
    data: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    function getVal() {
      if (props.data["url_for_check"] === null) {
        return "Нет"
      }

      return props.data["url_for_check"]
    }

    return {
      getVal,
    }
  }
})
</script>

<style scoped>

</style>
